export const LEAD_SELECT_COLUMNS =
  "id, first_name, last_name, company_name, email, phone, status, claimed_at, withdrawn_at, created_at, converted_at, converted_transaction_type, converted_stripe_subscription_id";

export const WITHDRAWN_STATUSES = new Set(["WITHDRAWN","RELEASED","CANCELLED","CANCELED"]);
export const CONVERTED_STATUSES = new Set(["CONVERTED","SUBSCRIBER","WON","CLOSED_WON","ACTIVE_SUBSCRIBER"]);
export const ENGAGED_STATUSES = new Set(["CONTACTED","ENGAGED","QUALIFIED","IN_PROGRESS","OPPORTUNITY"]);
export const DUPLICATE_STATUSES = new Set(["REJECTED_DUPLICATE","DUPLICATE"]);
export const INVALID_STATUSES = new Set(["REJECTED_INVALID"]);

export function normalizeAffiliateLeadStatus(value) {
  return String(value || "REGISTERED").trim().toUpperCase().replace(/[\s-]+/g, "_");
}
export function formatAffiliateStatus(value) {
  return normalizeAffiliateLeadStatus(value).toLowerCase().split("_").map((w)=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");
}
export function formatAffiliateDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-US",{month:"short",day:"numeric",year:"numeric"}).format(d);
}

const FUNCTION_ERROR_MESSAGES = {
  affiliate_not_found:
    "Your Sales Affiliate account could not be found. Refresh the page and try again.",
  lead_registration_affiliate_deactivated:
    "Prospect registration is unavailable because this Sales Affiliate account is deactivated.",
  lead_registration_not_allowed_in_state:
    "Prospect registration is not available for your current Sales Affiliate account status.",
  first_name_required: "First name is required.",
  last_name_required: "Last name is required.",
  company_name_required: "Company is required.",
  email_required: "Email is required.",
  email_format_invalid: "Enter a valid email address.",
  phone_format_invalid:
    "Enter a valid phone number using 5–40 characters: digits, spaces, +, -, parentheses, or periods.",
  lead_id_required: "The prospect record could not be identified. Refresh the page and try again.",
  lead_not_found_or_not_owned:
    "This protected prospect is no longer available in your portfolio. Refresh the page and try again.",
  lead_not_withdrawable_in_state:
    "This prospect can no longer be withdrawn in its current status. Refresh the list to see its latest status.",
  lead_registration_failed:
    "Unable to register this prospect right now. Please try again.",
  invalid_lead_registration_response:
    "Unable to confirm the prospect registration result. Please refresh and check your prospect list.",
  lead_withdrawal_failed:
    "Unable to withdraw this protected prospect right now. Please try again.",
  invalid_lead_withdrawal_response:
    "Unable to confirm the withdrawal result. Please refresh and check your prospect list.",
  request_body_must_be_json_object:
    "The prospect request could not be processed. Please refresh and try again.",
  invalid_json_body:
    "The prospect request could not be processed. Please refresh and try again.",
  unsupported_lead_action:
    "The requested prospect action is not supported.",
};

export function salesAffiliateFunctionCodeMessage(code, fallback) {
  const normalized = String(code || "").trim();
  return FUNCTION_ERROR_MESSAGES[normalized] || fallback;
}

export async function getSalesAffiliateFunctionErrorMessage(error, fallback) {
  let responseCode = "";

  try {
    const context = error?.context;
    if (context && typeof context.json === "function") {
      const response =
        typeof context.clone === "function" ? context.clone() : context;
      const payload = await response.json();
      if (payload && typeof payload.error === "string") {
        responseCode = payload.error;
      }
    }
  } catch {
    // If the structured response cannot be read, fall through to a safe
    // frontend message rather than replacing it with a transport-level error.
  }

  if (responseCode) {
    return salesAffiliateFunctionCodeMessage(responseCode, fallback);
  }

  const transportMessage =
    typeof error?.message === "string" ? error.message.trim() : "";

  if (
    transportMessage &&
    !/edge function returned a non-2xx status code/i.test(transportMessage)
  ) {
    return transportMessage;
  }

  return fallback;
}
